import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'
import {API_URL} from '../../../../_metronic/helpers'
import {UploadedFile} from '../../../../_metronic/helpers/components/uploadTypes'
import {AuthModel} from '../../auth/core/_models'
import {figureKindOfRole, figureKindTitle, figureUrl, genderOfTitle} from '../core/personFigure'
import {fullName} from '../core/profileFormat'
import './UserAvatar.css'

/**
 * Where a stored photo is read from. Photos saved before «حساب کاربری» was rebuilt and the ones it
 * saves now are both files of the upload store, listed in AuthModel.pic the same way.
 */
export const profilePhotoUrl = (file?: UploadedFile | null): string => {
  const source = String(file?.source || '').trim()
  if (!source) return ''
  if (/^(https?:|data:|blob:)/i.test(source)) return source
  if (source.startsWith('/api/')) return `${API_URL}${source.substring(4)}`
  return `${API_URL}/upload?load=${encodeURIComponent(source)}`
}

type Props = {
  // rl: the access in the business open now, for the figure's badge when there is no photo.
  user?: (Pick<AuthModel, 'fn' | 'ln' | 'un' | 'pic'> & Partial<Pick<AuthModel, 'rl'>>) | null
  // CSS pixels of the square.
  size?: number
  className?: string
  // Rounded square (the panel's tiles) or a circle (menus).
  shape?: 'circle' | 'rounded'
  // A preview URL that wins over the stored photo, e.g. right after saving.
  src?: string
}

/**
 * The user's photo, or - when there is none or it fails to load - their figure with the badge of their access
 * (60.11.599, core/personFigure), never the first letters of their name.
 */
export const UserAvatar: FC<Props> = ({user, size = 40, className, shape = 'circle', src}) => {
  const url = src || profilePhotoUrl(user?.pic?.[0])
  const [failed, setFailed] = useState(false)
  const name = fullName(user) || user?.un || 'کاربر'
  const kind = figureKindOfRole(user?.rl)
  const access = figureKindTitle(kind)

  useEffect(() => setFailed(false), [url])

  return (
    <span
      className={clsx('mp-user-avatar', `is-${shape}`, className, !(url && !failed) && 'is-figure')}
      style={{width: size, height: size}}
    >
      {url && !failed ? (
        <img src={url} alt={`تصویر ${name}`} onError={() => setFailed(true)} draggable={false} />
      ) : (
        <img
          src={figureUrl(genderOfTitle(name), kind, size < 32)}
          alt={access ? `تصویر ${name}، ${access}` : `تصویر ${name}`}
          title={access || undefined}
          draggable={false}
        />
      )}
    </span>
  )
}
